import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Global } from '@services/core/Global';

@Injectable({
    providedIn: 'root'
})
export class EntityService {
    private url = Global.url;
    private http = inject(HttpClient);

    getEntities(): Observable<any> {
        return this.http.get(`${this.url}V1/entities`);
    }

    create(entity: any): Observable<any> {
        return this.http.post(`${this.url}V1/entities`, entity);
    }

    update(params): Observable<any> {
        return this.http.put(`${this.url}V1/entities/${params.id}`, params);
    }

  
}
